import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import { apiServices } from "../../services/Api.js";


//get orders data
export const getOrdersData = createAsyncThunk(
    "orders/getOrdersData",
    async (id) => {
        try {
            const response = await apiServices.post(`/customer/${id}/orders`);
            return response;
        } catch (error) {
            console.error("Error fetching orders data:", error);
            throw error;
        }
    }
);




const initialState = {
    data: [],
    loading: false,
    error: ""
};

const OrderSlice = createSlice({
    name: "orders",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getOrdersData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getOrdersData.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action.payload);
                state.data = [action.payload];
            })
            .addCase(getOrdersData.rejected, (state) => {
                state.loading = false;
                state.error = "Error while fetching dashboard details";

                if (state.error) {
                    notification.error({
                        message: state.error
                    });
                }
            });
    },
});

const OrdersReducer = OrderSlice.reducer;

export default OrdersReducer;
